import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from "@tanstack/react-query";

import { DRAFT_STALE_TIME_MS } from "../constants";
import { isSegmentCountable, type DraftBody } from "../mappers";

import { segmentsQueryKeys } from "@/features/segments/api/queryKeys";
import type { OverrideImpactItem } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

export const canCheckOverrideImpact = (body: DraftBody) =>
  body.vacancyOverrides.length > 0 && isSegmentCountable(body);

export const overrideImpactQueryOptions = (
  segmentId: string | undefined,
  body: DraftBody,
) =>
  queryOptions({
    queryKey: segmentsQueryKeys.overrideImpact(segmentId, body),
    queryFn: ({ signal }) =>
      instance
        .post<OverrideImpactItem[]>(
          "/api/v2/Segments/drafts/overrides/impact",
          { ...body, segmentId },
          { signal },
        )
        .then((res) => res.data),
    staleTime: DRAFT_STALE_TIME_MS,
  });

export function useOverrideImpact(
  segmentId: string | undefined,
  body: DraftBody,
) {
  return useQuery({
    ...overrideImpactQueryOptions(segmentId, body),
    enabled: canCheckOverrideImpact(body),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
}
